import {
  CompareStockReconciliation,
  StartStockReconciliationUpload,
  StockReconciliationHistory,
  StockReconciliationHistoryItem,
  StockReconciliationQueue,
  StockReconciliationResult,
  StockReconciliationRowPage,
  StockReconciliationRowQuery,
  StockReconciliationUploadRow,
} from '@/types/StockReconciliation';
import {
  Core,
  STOCK_RECONCILIATION,
  STOCK_RECONCILIATION_COMPARE,
  STOCK_RECONCILIATION_QUEUE,
  STOCK_RECONCILIATION_ROWS,
  STOCK_RECONCILIATION_RUN,
  STOCK_RECONCILIATION_UPLOAD_COMPLETE,
  STOCK_RECONCILIATION_UPLOAD_FAIL,
  STOCK_RECONCILIATION_UPLOAD_ROWS,
  STOCK_RECONCILIATION_UPLOADS,
} from '../Core';

class StockReconciliationApi extends Core {
  startUpload = async (data: StartStockReconciliationUpload) =>
    this.post<StockReconciliationHistoryItem>(
      STOCK_RECONCILIATION_UPLOADS(),
      data,
    );

  appendRows = async (id: number, rows: StockReconciliationUploadRow[]) =>
    this.post<number>(STOCK_RECONCILIATION_UPLOAD_ROWS(id), rows);

  completeUpload = async (id: number) =>
    this.post<StockReconciliationHistoryItem>(
      STOCK_RECONCILIATION_UPLOAD_COMPLETE(id),
    );

  failUpload = async (id: number) =>
    this.post<StockReconciliationHistoryItem>(
      STOCK_RECONCILIATION_UPLOAD_FAIL(id),
    );

  enqueue = async (data: CompareStockReconciliation) =>
    this.post<StockReconciliationHistoryItem>(
      STOCK_RECONCILIATION_COMPARE(),
      data,
    );

  queue = async () =>
    this.get<StockReconciliationQueue>(STOCK_RECONCILIATION_QUEUE());

  save = async (data: StockReconciliationResult) =>
    this.post<StockReconciliationResult>(STOCK_RECONCILIATION(), data);

  getById = async (id: number) =>
    this.get<StockReconciliationResult>(STOCK_RECONCILIATION_RUN(id));

  rows = async (id: number, params: StockReconciliationRowQuery) =>
    this.get<StockReconciliationRowPage>(STOCK_RECONCILIATION_ROWS(id), {
      skip: params.skip,
      take: params.take,
      ...(params.sortField ? { sortField: params.sortField } : {}),
      ...(params.sortOrder ? { sortOrder: params.sortOrder } : {}),
      ...(params.search ? { search: params.search } : {}),
      ...(params.status ? { status: params.status } : {}),
      ...(params.location ? { location: params.location } : {}),
      ...(params.discrepanciesOnly ? { discrepanciesOnly: true } : {}),
      ...(params.exportAll ? { export: true } : {}),
    });

  list = async (params?: {
    customerId?: number;
    locationId?: number;
    skip?: number;
    take?: number;
  }) =>
    this.get<StockReconciliationHistory>(STOCK_RECONCILIATION(), {
      ...(params?.customerId != null ? { customerId: params.customerId } : {}),
      ...(params?.locationId != null ? { locationId: params.locationId } : {}),
      ...(params?.skip != null ? { skip: params.skip } : {}),
      ...(params?.take != null ? { take: params.take } : {}),
    });
}

export const stockReconciliation = new StockReconciliationApi();
